var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { PixelateWorker } from './pixelate.worker';
export const asyncImagePixelate = (source, size, opts) => __awaiter(void 0, void 0, void 0, function* () {
    const worker = new PixelateWorker();
    const result = yield new Promise((resolve, reject) => {
        const disposeWorker = (image, error) => {
            worker.onmessage = null;
            worker.onerror = null;
            worker.terminate();
            if (image) {
                resolve(image);
            }
            else {
                reject(error !== null && error !== void 0 ? error : new Error('Unknown processor error'));
            }
        };
        worker.onerror = (errorEvent) => {
            disposeWorker(undefined, errorEvent.error);
        };
        worker.onmessage = (message) => {
            const { data } = message;
            // handle error and quit early
            if ('error' in data) {
                const { error } = data;
                disposeWorker(undefined, new Error(error.message));
                return;
            }
            const { image } = data;
            if (!image) {
                disposeWorker(undefined, new Error('Missing image'));
                return;
            }
            // if you get here you are doomed
            disposeWorker(image);
        };
        // Launch worker code
        worker.postMessage({
            source,
            size: { width: size.width, height: size.height },
            opts,
        });
    });
    return result;
});
